/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindStandardsByClientIdQueryResponse,
  FindStandardsByClientIdPathParams,
} from "../types/FindStandardsByClientId.ts"

export const findStandardsByClientIdQueryKey = (
  clientId: FindStandardsByClientIdPathParams["clientId"]
) =>
  [
    {
      url: "/v1/standard/find-standards-by-client-id/:clientId",
      params: { clientId },
    },
  ] as const

export type FindStandardsByClientIdQueryKey = ReturnType<
  typeof findStandardsByClientIdQueryKey
>

/**
 * @summary Find standards by client id
 * {@link /v1/standard/find-standards-by-client-id/:clientId}
 */
export async function findStandardsByClientId(
  clientId: FindStandardsByClientIdPathParams["clientId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindStandardsByClientIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/standard/find-standards-by-client-id/${clientId}`,
    ...requestConfig,
  })
  return res
}

export function findStandardsByClientIdQueryOptions(
  clientId: FindStandardsByClientIdPathParams["clientId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findStandardsByClientIdQueryKey(clientId)
  return queryOptions<
    ResponseConfig<FindStandardsByClientIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindStandardsByClientIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!clientId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findStandardsByClientId(clientId, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find standards by client id
 * {@link /v1/standard/find-standards-by-client-id/:clientId}
 */
export function useFindStandardsByClientId<
  TData = ResponseConfig<FindStandardsByClientIdQueryResponse>,
  TQueryData = ResponseConfig<FindStandardsByClientIdQueryResponse>,
  TQueryKey extends QueryKey = FindStandardsByClientIdQueryKey,
>(
  clientId: FindStandardsByClientIdPathParams["clientId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindStandardsByClientIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findStandardsByClientIdQueryKey(clientId)

  const query = useQuery(
    {
      ...findStandardsByClientIdQueryOptions(clientId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
